"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lodestarTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _spacing = require("../constants/spacing");
var _getCSSVariables = require("./utils/getCSSVariables");
const lodestarTheme = {
  key: "lodestar-light",
  cssVariables: (0, _getCSSVariables.getCSSVariables)("com", "lodestar-light", _designTokens.commonTokens),
  skipLink: {
    container: {
      bg: (0, _designTokensReact.color)("color--background--surfaces--body"),
      borderRadius: `0 0 ${_spacing.sizes.xxSmall}px ${_spacing.sizes.xxSmall}px`,
      top: "0",
      padding: `0 ${_spacing.sizes.medium}px`,
      height: "40px",
      boxShadow: (0, _designTokensReact.color)("elevation--default"),
      gap: "xLarge"
    },
    button: {
      color: _designTokens.lodestarColors.ctaLink,
      padding: "3px 6px",
      fontSize: "13px",
      lineHeight: "normal",
      borderRadius: "4px",
      focusRingGap: -1
    }
  }
};
exports.lodestarTheme = lodestarTheme;
//# sourceMappingURL=lodestarTheme.js.map